(function(window) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.supportedPluginViewElements = Object.freeze({
      PROGRESS_BAR: 'progressBar',
      MEDIA: 'media'
   });
}(window));
